var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { transient, autoinject } from 'aurelia-dependency-injection';
import { Router } from 'aurelia-router';
import { TokenClient } from '../../../../services/authentication/token-client.service';
import { I18N } from 'aurelia-i18n';
import { ClientLotteryClientService } from '../../../../services/modules/client/client-lottery-client-service';
import { DialogClientService } from '../../../../services/basics/dialog-client.service';
import { ConfigClientService } from '../../../../services/modules/client-config.service';
import { RoutingHelper } from '../../../../helpers/routing.helper';
import { BaseLotteries } from '../../templates/base-lotteries';
var RenderLotteries = /** @class */ (function (_super) {
    __extends(RenderLotteries, _super);
    function RenderLotteries(lotteryClientService, router, tokenClient, i18n, dialogClient, configClientService, routingHelper) {
        return _super.call(this, lotteryClientService, router, tokenClient, i18n, dialogClient, configClientService, routingHelper) || this;
    }
    RenderLotteries = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [ClientLotteryClientService, Router, TokenClient,
            I18N, DialogClientService, ConfigClientService, RoutingHelper])
    ], RenderLotteries);
    return RenderLotteries;
}(BaseLotteries));
export { RenderLotteries };
